import { memo, useMemo } from 'react';

import { connectConfigService } from 'Lib/ConfigService';
import { LEVER_TOP_NAV_V2_DYNAMIC_ORDER } from 'Lib/ConfigService/levers';

import { I13nNav } from 'Components/I13n';

import navMapping from './navMapping';

type Props = {
  navOrder: string;
};

const BottomNav = (props: Props) => {
  const { navOrder } = props;

  const navByOrder = useMemo(() => {
    const orders = navOrder.split(',');
    return orders
      .map((navName) => {
        const NavComponent = navMapping[navName];
        if (NavComponent) {
          return <NavComponent key={navName} />;
        }
        return null;
      })
      .filter(Boolean);
  }, [navOrder]);

  return (
    <I13nNav
      className="W(100%) Pos(a) B(--safe-area-inset-bottom) Bgc($c-ds-background-primary)"
      i13nModel={{ label: 'BottomNav' }}
    >
      <div className="D(f) Jc(sa) Ai(c) My(2px)">{navByOrder}</div>
    </I13nNav>
  );
};

export const UnconnectedBottomNav = BottomNav;
export default connectConfigService({
  [LEVER_TOP_NAV_V2_DYNAMIC_ORDER]: 'navOrder',
})(memo(BottomNav));
